import { Box, Collapse } from '@mui/material';

import { PageSidebarItem } from '@/containers';

import { SidebarItems } from './useSidebarItems';

interface LearningPathsSidebarProps {
  items: SidebarItems;
}

export const LearningPathsSidebar = ({ items }: LearningPathsSidebarProps) => {
  const { inProgress, recommended, allTopics } = items;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {inProgress && (
        <PageSidebarItem
          label={inProgress.label}
          isActive={inProgress.isSelected}
          onClick={inProgress.onClick}
        />
      )}
      {recommended && (
        <PageSidebarItem
          label={recommended.label}
          isActive={recommended.isSelected}
          onClick={recommended.onClick}
        />
      )}
      <Box>
        <PageSidebarItem
          label={allTopics.label}
          isActive={allTopics.isSelected}
          onClick={allTopics.onClick}
          plain
        />
        <Collapse in={true} timeout="auto" unmountOnExit>
          {allTopics.children.map(child => (
            <PageSidebarItem
              key={child.label}
              label={child.label}
              isActive={child.isSelected}
              onClick={child.onClick}
              count={child.count}
              nested
            />
          ))}
        </Collapse>
      </Box>
    </Box>
  );
};
